// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import useApi from "../../../CustomHooks/useApi";
// import useRDService from "../../../CustomHooks/useRDService";
// import { Fingerprint, ArrowLeft } from "lucide-react";
// import $ from "jquery";

// export default function TwoFactorAuth1({ onBack, onSuccess }) {

//   const merchantdetails = useSelector(
//     (state) => state.auth?.employeeDetails
//   );

//   const userId = merchantdetails?.username;

//   // SAME LOCATION PICK LIKE EKYC
//   const { lat, lng } = useSelector(
//     (state) => state.location
//   );

//   const latitude = lat;
//   const longitude = lng;

//   const {
//     captureFingerprint,
//     loading: rdLoading
//   } = useRDService();

//   const { callApi: dailylogin } = useApi(
//     "/aeps/fingpay/daily-2fa",
//     "POST"
//   );


//   const { callApi: initiateMinKyc } = useApi(
//     "/aeps/fingpay/signup/min-kyc",
//     "POST"
//   );

//   const [captureLoading, setCaptureLoading] = useState(false);
//   const [retryLoading, setRetryLoading] = useState(false);

//   const [captureMessage, setCaptureMessage] = useState("");
//   const [retryError, setRetryError] = useState("");


//   const [showGeoForm, setShowGeoForm] = useState(false);

//   const [geoForm, setGeoForm] = useState({
//     name: merchantdetails?.name || "",
//     mobile: merchantdetails?.mobile_number || "",
//     email: merchantdetails?.email || "",
//     pan: merchantdetails?.pan || "",
//     aadhaar: merchantdetails?.aadhaar_number || "",
//     dob: merchantdetails?.dob || "",
//     gender: merchantdetails?.gender || "",
//     address: merchantdetails?.address?.full || "",
//     city: merchantdetails?.address?.city || "",
//     pincode: merchantdetails?.address?.pincode || ""
//   });

//   const formatDOB = (dob) => {
//     if (!dob) return "";
//     const d = new Date(dob);
//     return `${d.getFullYear()}-${String(
//       d.getMonth() + 1
//     ).padStart(2, "0")}-${String(
//       d.getDate()
//     ).padStart(2, "0")}`;
//   };


//   const handleGeoChange = (e) => {
//     setGeoForm({
//       ...geoForm,
//       [e.target.name]: e.target.value
//     });
//   };



//   const parsePidXml = (xml) => {

//     const $xml = $(xml);

//     const get = (selector, attr) =>
//       $xml.find(selector).attr(attr) || "0";

//     const infoValue = (name) =>
//       $xml.find(`Info[name='${name}']`).attr("value") ||
//       $xml.find(`Param[name='${name}']`).attr("value") ||
//       "0";

//     return {
//       dc: get("DeviceInfo", "dc"),
//       ci: get("Skey", "ci"),
//       hmac: $xml.find("Hmac").text() || "0",
//       dpId: get("DeviceInfo", "dpId"),
//       mc: get("DeviceInfo", "mc"),
//       pidDataType: get("Data", "type"),
//       sessionKey: $xml.find("Skey").text() || "0",
//       mi: get("DeviceInfo", "mi"),
//       rdsId: get("DeviceInfo", "rdsId"),
//       errCode: get("Resp", "errCode"),
//       errInfo: get("Resp", "errInfo"),
//       fCount: get("Resp", "fCount"),
//       fType: get("Resp", "fType"),
//       iCount: get("Resp", "iCount"), // blank hua toh 0 jayega
//       iType: get("Resp", "iType"),
//       pCount: get("Resp", "pCount"),
//       pType: "0",
//       srno: infoValue("srno"),
//       sysid: infoValue("sysid"),
//       ts: infoValue("ts"),
//       pidData: $xml.find("Data").text() || "0",
//       qScore: get("Resp", "qScore"),
//       nmPoints: get("Resp", "nmPoints"),
//       rdsVer: get("DeviceInfo", "rdsVer"),
//     };
//   };



//   const handle2FALogin = async () => {

//     try {
//       setCaptureLoading(true);
//       setCaptureMessage("Place finger on scanner...");
//       setRetryError(""); // old retry error clear

//       const pidXml = await captureFingerprint("");

//       if (!pidXml || !pidXml.includes('errCode="0"')) {
//         setCaptureMessage("Fingerprint capture failed");
//         return;
//       }

//       const pidData = parsePidXml(pidXml);

//       const response = await dailylogin(
//         {mid:userId,

         
//           latitude: latitude?.toString(),
//           longitude: longitude?.toString(),
//           biometricData: pidData
//         },
//         // `?userId=${userId}`
//       );

//       if (response?.statuscode === "TXN") {
//         setCaptureMessage("✅ Daily 2FA Login Successful");

//         if (onSuccess) {
//           setTimeout(() => {
//             onSuccess();
//           }, 1200)
//         }

//       } else if (
//         response?.statuscode === "ERR" &&
//         response?.status?.includes("Geo-fencing authentication failed")
//       ) {
//         setCaptureMessage(response.status);
//         setShowGeoForm(true);
//         return;
//       }
//       else {
//         setCaptureMessage(
//           response?.status ||
//           response?.message ||
//           "Authentication failed"
//         );
//       }

//     } catch (error) {
//       setCaptureMessage(
//         error?.message || "Something went wrong"
//       );
//     } finally {
//       setCaptureLoading(false);
//     }

//   }


//   const retryGeoKyc = async () => {

//     try {

//       setRetryLoading(true);
//       setRetryError("");

//       const body = {
//         mobile: geoForm.mobile,
//         name: geoForm.name,
//         gender: geoForm.gender,
//         pan: geoForm.pan.toUpperCase(),
//         email: geoForm.email,
//         aadhaar: geoForm.aadhaar,
//         dateOfBirth: formatDOB(geoForm.dob),
//         latitude: latitude?.toString(),
//         longitude: longitude?.toString(),
//         address: {
//           full: geoForm.address,
//           city: geoForm.city,
//           pincode: geoForm.pincode
//         }
//       };

//       const res = await initiateMinKyc(
//         body,
//         `?userId=${userId}`
//       );

//       if (res?.statuscode === "TXN") {
//         setRetryError("");
//         setShowGeoForm(false);
//         setCaptureMessage("Min KYC completed. Now Try 2-FA");
//         return;
//       }

//       setRetryError(
//         res?.message ||
//         "Retry failed"
//       );

//     } catch (error) {
//       setRetryError("Something went wrong");
//     } finally {
//       setRetryLoading(false);
//     }

//   }



//   return (
//     <div className="bg-[#F5F7FB] px-6 py-10">
//       <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start justify-center gap-8">

//         {/* LEFT CAPTURE CARD */}
//         <div className="w-full lg:w-[420px] sticky top-10">
//           <div className="bg-white rounded-3xl shadow-xl p-8">

//             <button
//               onClick={onBack}
//               className="flex items-center gap-2 mb-8 text-gray-600 hover:text-blue-600"
//             >
//               <ArrowLeft size={18} />
//               Back
//             </button>

//             <div className="w-24 h-24 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-6">
//               <Fingerprint size={50} className="text-blue-600" />
//             </div>

//             <h2 className="text-2xl font-semibold text-center mb-3">
//               Daily 2FA Authentication
//             </h2>

//             <p className="text-gray-500 text-center mb-8">
//               Capture fingerprint for outlet login
//             </p>

//             <button
//               onClick={handle2FALogin}
//               disabled={captureLoading || rdLoading}
//               className="w-full bg-blue-600 text-white py-4 rounded-xl hover:bg-blue-700 font-medium"
//             >
//               {captureLoading || rdLoading
//                 ? "Capture Processing..."
//                 : "Capture Fingerprint"}
//             </button>

//             {captureMessage && (
//               <div className="mt-5 p-4 rounded-xl bg-blue-50 border text-sm text-center">
//                 {captureMessage}
//               </div>
//             )}

//           </div>
//         </div>


//         {/* RIGHT SIDE GEO FORM */}
//         {showGeoForm && (
//           <div className="flex-1 w-full animate-slideInRight">
//             <div className="bg-white rounded-3xl shadow-xl p-8 border">

//               <div className="mb-6">
//                 <h3 className="text-2xl font-semibold text-red-600 mb-2">
//                   Geo Fencing Failed
//                 </h3>

//                 <p className="text-gray-500">
//                   Update details and retry E-KYC
//                 </p>
//               </div>

//               <div className="grid md:grid-cols-2 gap-5">

//                 <Input
//                   label="Name"
//                   name="name"
//                   value={geoForm.name}
//                   onChange={handleGeoChange}
//                 />

//                 <Input
//                   label="Mobile"
//                   name="mobile"
//                   value={geoForm.mobile}
//                   onChange={handleGeoChange}
//                 />

//                 <Input
//                   label="Email"
//                   name="email"
//                   value={geoForm.email}
//                   onChange={handleGeoChange}
//                 />

//                 <Input
//                   label="PAN"
//                   name="pan"
//                   value={geoForm.pan}
//                   onChange={handleGeoChange}
//                 />

//                 <Input
//                   label="Aadhaar"
//                   name="aadhaar"
//                   value={geoForm.aadhaar}
//                   onChange={handleGeoChange}
//                 />

//                 <Input
//                   type="date"
//                   label="DOB"
//                   name="dob"
//                   value={geoForm.dob}
//                   onChange={handleGeoChange}
//                 />

//                 <div>
//                   <label className="block mb-2 font-medium">
//                     Gender
//                   </label>

//                   <select
//                     name="gender"
//                     value={geoForm.gender}
//                     onChange={handleGeoChange}
//                     className="w-full border rounded-xl p-3"
//                   >
//                     <option value="">Select</option>
//                     <option value="M">Male</option>
//                     <option value="F">Female</option>
//                     <option value="T">Transgender</option>
//                   </select>
//                 </div>

//                 <Input
//                   label="Address"
//                   name="address"
//                   value={geoForm.address}
//                   onChange={handleGeoChange}
//                 />

//                 <Input
//                   label="City"
//                   name="city"
//                   value={geoForm.city}
//                   onChange={handleGeoChange}
//                 />

//                 <Input
//                   label="Pincode"
//                   name="pincode"
//                   value={geoForm.pincode}
//                   onChange={handleGeoChange}
//                 />

//               </div>

//               <button
//                 onClick={retryGeoKyc}
//                 disabled={retryLoading}
//                 className="w-full mt-8 bg-blue-600 text-white py-4 rounded-xl hover:bg-blue-700 font-semibold"
//               >
//                 {retryLoading
//                   ? "Retrying E-KYC..."
//                   : "Retry E-KYC"}
//               </button>

//               {retryError && (
//                 <div className="mt-4 p-4 rounded-xl bg-red-50 border border-red-200 text-red-600 text-sm text-center">
//                   {retryError}
//                 </div>
//               )}

//             </div>
//           </div>
//         )}

//       </div>
//     </div>
//   );
// }

// function Input({ label, ...props }) {
//   return (
//     <div>
//       <label className="block mb-1">
//         {label}
//       </label>

//       <input
//         {...props}
//         className="w-full border rounded-lg p-3"
//       />
//     </div>
//   );
// }



  import React, { useState } from "react";
import { useSelector } from "react-redux";
import useApi from "../../../CustomHooks/useApi";
import useRDService from "../../../CustomHooks/useRDService";
import { Fingerprint, ArrowLeft, CheckCircle, XCircle } from "lucide-react";
import $ from "jquery";

export default function TwoFactorAuth1({ onBack, onSuccess }) {

  const merchantdetails = useSelector(
    (state) => state.auth?.employeeDetails
  );

  const userId = merchantdetails?.username;

  // SAME LOCATION PICK LIKE EKYC
  const { lat, lng } = useSelector(
    (state) => state.location
  );

  const latitude = lat;
  const longitude = lng;

  const {
    captureFingerprint,
    loading: rdLoading
  } = useRDService();

  const { callApi: dailylogin } = useApi(
    "/aeps/fingpay/daily-2fa",
    "POST"
  );

  const { callApi: initiateMinKyc } = useApi(
    "/aeps/fingpay/signup/min-kyc",
    "POST"
  );

  const [captureLoading, setCaptureLoading] = useState(false);
  const [retryLoading, setRetryLoading] = useState(false);
  const [retryError, setRetryError] = useState("");

  const [showGeoForm, setShowGeoForm] = useState(false);

  // POPUP STATE
  const [popup, setPopup] = useState({
    show: false,
    type: "success", // 'success' or 'error'
    message: ""
  });

  const [geoForm, setGeoForm] = useState({
    name: merchantdetails?.name || "",
    mobile: merchantdetails?.mobile_number || "",
    email: merchantdetails?.email || "",
    pan: merchantdetails?.pan || "",
    aadhaar: merchantdetails?.aadhaar_number || "",
    dob: merchantdetails?.dob || "",
    gender: merchantdetails?.gender || "",
    address: merchantdetails?.address?.full || "",
    city: merchantdetails?.address?.city || "",
    pincode: merchantdetails?.address?.pincode || ""
  });

  const formatDOB = (dob) => {
    if (!dob) return "";
    const d = new Date(dob);
    return `${d.getFullYear()}-${String(
      d.getMonth() + 1
    ).padStart(2, "0")}-${String(
      d.getDate()
    ).padStart(2, "0")}`;
  };

  const handleGeoChange = (e) => {
    setGeoForm({
      ...geoForm,
      [e.target.name]: e.target.value
    });
  };

  const parsePidXml = (xml) => {
    const $xml = $(xml);

    const get = (selector, attr) =>
      $xml.find(selector).attr(attr) || "0";

    const infoValue = (name) =>
      $xml.find(`Info[name='${name}']`).attr("value") ||
      $xml.find(`Param[name='${name}']`).attr("value") ||
      "0";

    return {
      dc: get("DeviceInfo", "dc"),
      ci: get("Skey", "ci"),
      hmac: $xml.find("Hmac").text() || "0",
      dpId: get("DeviceInfo", "dpId"),
      mc: get("DeviceInfo", "mc"),
      pidDataType: get("Data", "type"),
      sessionKey: $xml.find("Skey").text() || "0",
      mi: get("DeviceInfo", "mi"),
      rdsId: get("DeviceInfo", "rdsId"),
      errCode: get("Resp", "errCode"),
      errInfo: get("Resp", "errInfo"),
      fCount: get("Resp", "fCount"),
      fType: get("Resp", "fType"),
      iCount: get("Resp", "iCount"), // blank hua toh 0 jayega
      iType: get("Resp", "iType"),
      pCount: get("Resp", "pCount"),
      pType: "0",
      srno: infoValue("srno"),
      sysid: infoValue("sysid"),
      ts: infoValue("ts"),
      pidData: $xml.find("Data").text() || "0",
      qScore: get("Resp", "qScore"),
      nmPoints: get("Resp", "nmPoints"),
      rdsVer: get("DeviceInfo", "rdsVer"),
    };
  };

  // HELPER TO EXTRACT EXACT MESSAGE FROM BACKEND STRING
  const extractBackendMessage = (rawStr) => {
    if (!rawStr || typeof rawStr !== "string") return "Something went wrong";
    
    // Looks for "Message :" or "Message:" and captures everything after it
    const match = rawStr.match(/Message\s*:\s*(.*)/i);
    if (match && match[1]) {
      return match[1].trim();
    }
    return rawStr; // Fallback to raw string if "Message :" isn't found
  };

  const handle2FALogin = async () => {
    try {
      setCaptureLoading(true);
      setRetryError("");

      const pidXml = await captureFingerprint("");

      if (!pidXml || !pidXml.includes('errCode="0"')) {
        setPopup({ show: true, type: "error", message: "Fingerprint capture failed on device." });
        return;
      }

      const pidData = parsePidXml(pidXml);

      const response = await dailylogin({
        mid: userId,
        latitude: latitude?.toString(),
        longitude: longitude?.toString(),
        biometricData: pidData
      });

      // SUCCESS CASE
      if (response?.statuscode === "TXN" || response?.status === "SUCCESS") {
        const successMsg = extractBackendMessage(response?.message || response?.status || "Login Successful");
        setPopup({ show: true, type: "success", message: successMsg });

        if (onSuccess) {
          setTimeout(() => {
            setPopup({ show: false, type: "success", message: "" });
            onSuccess();
          }, 2000); // 2 seconds delay to let user read the popup
        }

      } 
      // GEO-FENCING ERROR CASE
      else if (
        response?.statuscode === "ERR" &&
        response?.status?.includes("Geo-fencing authentication failed")
      ) {
        const errorMsg = extractBackendMessage(response?.message || response?.status);
        setPopup({ show: true, type: "error", message: errorMsg });
        setShowGeoForm(true);
      } 
      // OTHER ERROR CASE
      else {
        const errorMsg = extractBackendMessage(response?.message || response?.status || "Authentication failed");
        setPopup({ show: true, type: "error", message: errorMsg });
      }

    } catch (error) {
      // Prioritize error.response.data.message for standard HTTP 400 errors from backend
      const rawErrorMsg = 
        error?.response?.data?.message || 
        error?.message || 
        "Something went wrong with the request.";
      
      const finalErrorMsg = extractBackendMessage(rawErrorMsg);
      setPopup({ show: true, type: "error", message: finalErrorMsg });
      
    } finally {
      setCaptureLoading(false);
    }
  };

  const retryGeoKyc = async () => {
    try {
      setRetryLoading(true);
      setRetryError("");

      const body = {
        mobile: geoForm.mobile,
        name: geoForm.name,
        gender: geoForm.gender,
        pan: geoForm.pan.toUpperCase(),
        email: geoForm.email,
        aadhaar: geoForm.aadhaar,
        dateOfBirth: formatDOB(geoForm.dob),
        latitude: latitude?.toString(),
        longitude: longitude?.toString(),
        address: {
          full: geoForm.address,
          city: geoForm.city,
          pincode: geoForm.pincode
        }
      };

      const res = await initiateMinKyc(
        body,
        `?userId=${userId}`
      );

      if (res?.statuscode === "TXN") {
        setRetryError("");
        setShowGeoForm(false);
        setPopup({ show: true, type: "success", message: "Min KYC completed. Now Try 2-FA" });
        return;
      }

      setRetryError(res?.message || "Retry failed");

    } catch (error) {
      setRetryError("Something went wrong");
    } finally {
      setRetryLoading(false);
    }
  };

  return (
    <div className="bg-[#F5F7FB] px-6 py-10 min-h-screen relative">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start justify-center gap-8">

        {/* LEFT CAPTURE CARD */}
        <div className="w-full lg:w-[420px] sticky top-10">
          <div className="bg-white rounded-3xl shadow-xl p-8">

            <button
              onClick={onBack}
              className="flex items-center gap-2 mb-8 text-gray-600 hover:text-blue-600 transition-colors"
            >
              <ArrowLeft size={18} />
              Back
            </button>

            <div className="w-24 h-24 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-6">
              <Fingerprint size={50} className={`text-blue-600 ${(captureLoading || rdLoading) ? 'animate-pulse' : ''}`} />
            </div>

            <h2 className="text-2xl font-semibold text-center mb-3 text-gray-800">
              Daily 2FA Authentication
            </h2>

            <p className="text-gray-500 text-center mb-8">
              {(captureLoading || rdLoading) ? "Waiting for device scan..." : "Capture fingerprint for outlet login"}
            </p>

            <button
              onClick={handle2FALogin}
              disabled={captureLoading || rdLoading}
              className="w-full bg-blue-600 text-white py-4 rounded-xl hover:bg-blue-700 font-medium transition-all disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {captureLoading || rdLoading
                ? "Processing..."
                : "Capture Fingerprint"}
            </button>

          </div>
        </div>

        {/* RIGHT SIDE GEO FORM */}
        {showGeoForm && (
          <div className="flex-1 w-full animate-slideInRight">
            <div className="bg-white rounded-3xl shadow-xl p-8 border border-gray-100">

              <div className="mb-6">
                <h3 className="text-2xl font-semibold text-red-600 mb-2">
                  Geo Fencing Failed
                </h3>

                <p className="text-gray-500">
                  Update details and retry E-KYC
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-5">

                <Input
                  label="Name"
                  name="name"
                  value={geoForm.name}
                  onChange={handleGeoChange}
                />

                <Input
                  label="Mobile"
                  name="mobile"
                  value={geoForm.mobile}
                  onChange={handleGeoChange}
                />

                <Input
                  label="Email"
                  name="email"
                  value={geoForm.email}
                  onChange={handleGeoChange}
                />

                <Input
                  label="PAN"
                  name="pan"
                  value={geoForm.pan}
                  onChange={handleGeoChange}
                />

                <Input
                  label="Aadhaar"
                  name="aadhaar"
                  value={geoForm.aadhaar}
                  onChange={handleGeoChange}
                />

                <Input
                  type="date"
                  label="DOB"
                  name="dob"
                  value={geoForm.dob}
                  onChange={handleGeoChange}
                />

                <div>
                  <label className="block mb-2 font-medium text-gray-700">
                    Gender
                  </label>

                  <select
                    name="gender"
                    value={geoForm.gender}
                    onChange={handleGeoChange}
                    className="w-full border border-gray-300 rounded-xl p-3 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  >
                    <option value="">Select</option>
                    <option value="M">Male</option>
                    <option value="F">Female</option>
                    <option value="T">Transgender</option>
                  </select>
                </div>

                <Input
                  label="Address"
                  name="address"
                  value={geoForm.address}
                  onChange={handleGeoChange}
                />

                <Input
                  label="City"
                  name="city"
                  value={geoForm.city}
                  onChange={handleGeoChange}
                />

                <Input
                  label="Pincode"
                  name="pincode"
                  value={geoForm.pincode}
                  onChange={handleGeoChange}
                />

              </div>

              <button
                onClick={retryGeoKyc}
                disabled={retryLoading}
                className="w-full mt-8 bg-blue-600 text-white py-4 rounded-xl hover:bg-blue-700 font-semibold transition-all disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {retryLoading
                  ? "Retrying E-KYC..."
                  : "Retry E-KYC"}
              </button>

              {retryError && (
                <div className="mt-4 p-4 rounded-xl bg-red-50 border border-red-200 text-red-600 text-sm text-center">
                  {retryError}
                </div>
              )}

            </div>
          </div>
        )}

      </div>

      {/* PROFESSIONAL POPUP MODAL */}
      {popup.show && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
          <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-sm text-center transform transition-all scale-100 opacity-100">
            <div className="flex justify-center mb-4">
              {popup.type === "success" ? (
                <CheckCircle size={56} className="text-green-500" />
              ) : (
                <XCircle size={56} className="text-red-500" />
              )}
            </div>
            
            <h3 className={`text-2xl font-bold mb-3 ${popup.type === "success" ? "text-green-600" : "text-red-600"}`}>
              {popup.type === "success" ? "Success" : "Failed"}
            </h3>
            
            <p className="text-gray-600 mb-8 font-medium leading-relaxed text-base">
              {popup.message}
            </p>
            
            <button
              onClick={() => setPopup({ show: false, type: "success", message: "" })}
              className={`w-full py-3.5 rounded-xl font-semibold text-white transition-colors ${
                popup.type === "success" ? "bg-green-600 hover:bg-green-700" : "bg-red-600 hover:bg-red-700"
              }`}
            >
              Okay
            </button>
          </div>
        </div>
      )}

    </div>
  );
}

function Input({ label, ...props }) {
  return (
    <div>
      <label className="block mb-1 font-medium text-gray-700">
        {label}
      </label>

      <input
        {...props}
        className="w-full border border-gray-300 rounded-xl p-3 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors"
      />
    </div>
  );
}